import React, { useEffect, useState } from 'react';

import styles from './HealthCardAdDistributionYear.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../../Auth';
import { useAxios } from '../../../../../../../AxiosHandler';
import LineGraphCard from '../../../../Cards/LineGraphCard/LineGraphCard';

function HealthCardAdDistributionYear(props: HealthCardAdDistributionYearProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/ad/breed/" + auth.selectedBreed + "/distributionyear",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            let dataSets = [
                { label: "0", color: "#68DB5A" },
                { label: "1", color: "#A6F65D" },
                { label: "2", color: "#FFE144" },
                { label: "3", color: "#F89D27" }
            ]

            if (res.data?.length > 0) {
                setData({
                    labels: res.data.map((i: any) => i["YEAR"]),
                    datasets: [...dataSets.map((i: any) => {
                            return {
                                label: i.label,
                                backgroundColor: "transparent",
                                pointBackgroundColor: i.color,
                                borderColor: i.color,
                                pointRadius: 2,
                                data: res.data.map((j: any) => j[i.label]),
                                tension: 0.5
                            }
                        }),
                        {
                            label: t("statistics.areas.health.graphs.ad.distributionyear.not_checked"),
                            backgroundColor: "transparent",
                            pointBackgroundColor: "#FF2F45",
                            borderColor: "#FF2F45",
                            pointRadius: 2,
                            data: res.data.map((j: any) => j["NOT_DIAGNOSED"]),
                            tension: 0.5
                        }
                    ]
                });
            } else {
                setData(undefined);
            }
            
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth} style={{ display: data == undefined || data.length == 0 ? "none" : "block" }}>
            <LineGraphCard
                title={t("statistics.areas.health.graphs.ad.distributionyear.title")}
                data={data}
                description={t("statistics.areas.health.graphs.ad.distributionyear.description")}
            ></LineGraphCard>
        </div>
    );
}

class HealthCardAdDistributionYearProps {
    onDataLoaded?: (data: any) => void;
}

export default HealthCardAdDistributionYear;